export default {
  title: {
    login: '登录',
    createPassword: '创建你的密码',
    forgetPassword: '忘记密码',
    resetPassword: '重置密码',
    questionnaire: '满意度调查',
    alert: '请查看您的邮件',
    statement: '隐私内容协议'
  },
  btn: {
    home: '首页',
    forgetPassword: '忘记密码',
    reset: '重置',
    confirm: '确认',
    upload: '上传',
    addEntry: '新增',
    remove: '删除',
    back: '返回',
    cancel: '取消',
    next: '下一步',
    finish: '完成',
    submit: '提交',
    viewJobs: '查看所有职位',
    viewResume: '查看简历',
    viewApplicant: '查看申请状态',
    viewHMDashboard: '查看HM看板'
  },
  label: {
    year: '{year} 年',
    language: '语言',
    email: '邮箱',
    userName: '用户名',
    firstName: '名',
    lastName: '姓',
    password: '密码',
    reEnterPassword: '再次输入密码',
    agreeStatement: '我已经阅读并接受隐私内容协议',
    toEmployeePortal: '去员工中心',
    statementBody: '',
    thanksLabel: '谢谢!',
    finishContent: '您的{questionnaire}已经提交，祝您好运！',
    moreInformation: '更多信息：',
    scanToFollowWeChat: '扫一扫关注我们的微信吧！',
    followWeChat: '点击关注微信公众号',
    followWeChatDesc: '实时接收简历投递状态更新，以及获取更多职位信息。',
    toWeChat: '前往公众号 >',
    present: '至今',
    entryNo: '第 {number} 段',
    startDate: '开始时间',
    endDate: '结束时间',
    status: '状态',
    pending: '待填写',
    submitted: '已提交',
    cancelled: '已取消',
    noData: '暂无数据',
    configMissing: '配置缺失',
    step: '步骤',
    confirmed: '已确认',
    unconfirmed: '未确认',
    signature: '签名',
    clickToSign: '点击签名',
    resign: '重新签名',
    jobApplication: '应聘登记表',
    jobApplicationRecord: '应聘登记表记录',
    operationRecords: '操作记录',
    jobApplicationInviteRecord: '{name} 于 {time} 邀请应聘登记',
    jobApplicationReminderRecord: '{name} 于 {time} 提醒填写应聘登记',
    jobApplicationCompleteRecord: '{name} 于 {time} 完成应聘登记',
    jobApplicationReactivateRecord: '{name} 于 {time} 重新激活，原因：{reason}',
    jobApplicationStatusInvited: '应聘登记已邀请',
    jobApplicationStatusReminded: '应聘登记已提醒',
    jobApplicationStatusCompleted: '应聘登记已完成',
    jobApplicationStatusReactivated: '应聘登记已重新激活'
  },
  message: {
    resetEmailSuccess: '重置密码邮件已发送到您的邮箱，请查看您的邮箱继续。',
    wrongEmail: '无法重置密码，请检查填写的邮箱地址',
    questionnaireFinished: '已完成调查问卷',
    questionnaireFinishedText1: '恭喜你已完成了全部問題',
    questionnaireStepZeroText1: '请按照以下流程填写信息。',
    questionnaireStepZeroText2: '使用流程下方的按钮进行导航。',
    questionnaireStepZeroText3: '点击取消键可以再次进入调查问卷界面填写信息，之前填写的信息会被保存。',
    fileChangedButNoUpload: '文件已修改但未上传，确认离开？'
  },
  error: {
    passwordNotSame: '两次输入的密码不一致',
    fileNotUpload: '请上传附件',
    fileSize: '文件大小不能超过4MB',
    isRequired: '该字段不能为空',
    login: '用户名或密码错误',
    passwordTip: '密码必须包含大小写字母和数字，长度至少10位，特殊符号只能是_#@.-',
    noSteps: '未获取到调查问卷具体步骤，请刷新重试',
    uploadError: '上传文件失败，请重试',
    uploadSuccess: '上传文件成功',
    phoneError: '电话格式不正确',
    birthIsNeeded: '需要提供出生日期。',
    ageTooSmall: '您已经指出您的年龄不足16岁。您必须至少16岁，这样才能为我们公司工作。',
    nameNotEn: '请检查并确保您是以拼音或者英文作为输入方可进入下一页',
    nationalIDIssueDateIsNeeded: '要求提供国民身份证签发日期',
    nationalIDExpireDateIsNeeded: '要求提供国民身份证到期日期',
    nationalIDExpireLargeThanIssue: '国民身份证签发日期应当早于到期日期。',
    nationalIDExpireLargeThanNow: '国民身份证到期日期应该是将来的某个日期。',
    nationalIDRegex: '请输入有效的{nationID}。使用格式{format}',
    mustSelected: '该选项必须勾选',
    tryAgain: '请重试',
    minRows: '至少需要填写 {count} 段',
    signatureRequired: '请完成签名',
    signatureUploadFailed: '签名上传失败，请重试'
  }
}
